import { RuntimeOptions } from 'firebase-functions/v1';
import { Stripe } from 'stripe';

export const LIMIT_BOOKS_TO_ORDER = 4;
export const LIMIT_BOOKS_FOR_DEFAULT_SHIPPING = 1;

export const DEFAULT_SHIPPING_PRICE = 385;

export const GIFT_WRAPPING_PRICE = 300;

// * prices
export const BOOK_PRICE_STARRY_DREAM = 3900;

export const BOOK_PRICE_STARRY_DREAM_HARD_COVER = 4900;

export const BOOK_PRICE_WELCOME_TO_THE_WOLD = 3700;

export const BOOK_PRICE_WELCOME_TO_THE_WOLD_HARD_COVER = 4700;

export const BOOK_PRICE_WHOS_BIRTHDAY_TOMORROW = 3500;

export const BOOK_PRICE_WHOS_BIRTHDAY_TOMORROW_HARD_COVER = 4500;

// * stripe
/** supported types by buki */
export const STRIPE_PAYMENT_METHOD_TYPE_CARD = 'card';
export const STRIPE_PAYMENT_METHOD_TYPE_KONBINI = 'konbini';
export const STRIPE_PAYMENT_METHOD_TYPES: Stripe.PaymentIntentCreateParams['payment_method_types'] =
  [STRIPE_PAYMENT_METHOD_TYPE_CARD, STRIPE_PAYMENT_METHOD_TYPE_KONBINI];

// * db
export const DB_SYSTEM = 'system';
export const DB_PRINT = 'print';
export const DB_GIFTS = 'gifts';
export const DB_GIFT = 'gift';
export const DB_PARAMETERS = 'parameters';
export const DB_DISCOUNT_CAMPAIGNS = 'discountCampaigns';
export const DB_USERS = 'users';
export const DB_STRIPE_CUSTOMERS = 'stripe_customers';
export const DB_PAYMENTS = 'payments';
export const DB_GIFT_PAYMENTS = 'gift_payments';
export const DB_PAYMENT_METHODS = 'payment_methods';
export const DB_ORDERS = 'orders';
export const DB_GIFT_ORDERS = 'giftOrders';
export const DB_COUPONS = 'coupons';
export const DB_BOOKS = 'books';
export const DB_TRANSFER = 'transfer';

export const FUNCTIONS_RUNTIME_OPTIONS: RuntimeOptions = {
  timeoutSeconds: 540,
  memory: '512MB',
};
